import React, { useState } from "react";
import {
    Box,
    Tabs,
    Tab,
    Typography,
    Grid,
    TextField,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import BadgeIcon from "@mui/icons-material/Badge";
import SchoolIcon from "@mui/icons-material/School";
import WorkIcon from "@mui/icons-material/Work";
import BasicDetailsForm from "./BasicDetailsForm";
import QualificationForm from "./QualificationForm";
import WorkExperienceForm from "./WorkExperienceForm";



const PersonalDetails = ({ companyId, employeeId }) => {
    const [innerTab, setInnerTab] = useState(0);
    const theme = useTheme();

    // Mobile check for dynamic tab width alignment
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleInnerTabChange = (event, newValue) => {
        setInnerTab(newValue);
    };

    // Switch routing logic to change nested sheets
    const renderSubPage = (index) => {
        switch (index) {
            case 0:
                return <BasicDetailsForm companyId={companyId} employeeId={employeeId} />;
            case 1:
                return <QualificationForm companyId={companyId} employeeId={employeeId} />;
            case 2:
                return <WorkExperienceForm companyId={companyId} employeeId={employeeId}/>;
            default:
                return <BasicDetailsForm companyId={companyId} employeeId={employeeId} />;
        }
    };

    return (
        <Box sx={{ py: 1 }}>
            {/* INTERNAL SUB-TABS NAVIGATION BAR */}
            <Box
                sx={{
                    borderBottom: 1,
                    borderColor: "divider",
                    mb: 3,
                    bgcolor: "#f8fafc", // Light neutral wrap background
                    borderRadius: "12px",
                    p: 0.5
                }}
            >
                <Tabs
                    value={innerTab}
                    onChange={handleInnerTabChange}
                    variant={isMobile ? "scrollable" : "standard"} // Mobile par scroll support milega
                    scrollButtons="auto"
                    allowScrollButtonsMobile
                    textColor="primary"
                    indicatorColor="primary"
                    sx={{
                        "& .MuiTab-root": {
                            textTransform: "none",
                            fontWeight: "600",
                            minHeight: "44px",
                            py: 1,
                            borderRadius: "8px",
                            fontSize: { xs: "13px", sm: "14px" },
                            transition: "all 0.2s ease-in-out",
                            "&.Mui-selected": {
                                bgcolor: "#fff", // Professional active chip highlight effect
                                boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                            }
                        },
                        "& .MuiTabs-indicator": {
                            display: isMobile ? "block" : "none" // Mobile screen pe indicator line achhi lagti hai, desktop pe chips clean hain
                        }
                    }}
                >
                    <Tab icon={<BadgeIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Basic Details" />
                    <Tab icon={<SchoolIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Qualification" />
                    <Tab icon={<WorkIcon sx={{ fontSize: 18 }} />} iconPosition="start" label="Work Experience" />
                </Tabs>
            </Box>

            {/* INNER DYNAMIC FORM SHEET CONTEXT */}
            <Box sx={{ px: { xs: 0, sm: 1 } }}>
                {renderSubPage(innerTab)}
            </Box>
        </Box>
    );
};

export default PersonalDetails;